import {Component, Input} from '@angular/core';
import {Period} from '../../generated/sales-terminal-client';
import {UtilService} from '../../services/util/util.service';

export interface EventProps {
  id?: number;
  eventPeriod?: Period;
  timezone?: string;
  venueTitle?: string;
  onlineLocation?: string;
  salesPeriod?: Period;
}

@Component({
  selector: 'app-event-info-props',
  templateUrl: './event-info-props.component.html'
})
export class EventInfoPropsComponent {
  @Input() eventProps: EventProps;
  @Input() hideLocation: boolean;
  @Input() hideId: boolean;
  @Input() manualWrapper: boolean;
  @Input() showFullLink: boolean;
  @Input() showWeekday: boolean;
  @Input() displayOnlineLocationPlaceholder: boolean;
  @Input() muted: boolean;
  @Input() alignRight: boolean;

  constructor(public utilService: UtilService) {}
}
